import { Link } from "react-router-dom";

export default function Footer() {
  return (
    <footer style={styles.footer}>
      <div style={styles.container}>
        <div style={styles.section}>
          <h4 style={styles.heading}>Branding & Events Studio</h4>
          <p style={styles.description}>
            Personalised branding solutions and seamless event planning,
            designed with care and professionalism.
          </p>
        </div>

        <div style={styles.section}>
          <h4 style={styles.heading}>Contact</h4>
          <p style={styles.link}>brandingandevents@gmail.com</p>
          <p style={styles.link}>+27 64 074 3199</p>
          <p style={styles.link}>Cape Town, South Africa</p>
        </div>

        <div style={styles.section}>
          <h4 style={styles.heading}>Follow Us</h4>
          <div style={styles.socials}>
            <a
              href="https://www.instagram.com/brandingevents_studio?igsh=MW81eXFtbG5iOGw4NA%3D%3D&utm_source=qr"
              style={styles.socialLink}
            >
              Instagram
            </a>
            <a
              href="https://www.facebook.com/profile.php?id=61586930339814"
              style={styles.socialLink}
            >
              Facebook
            </a>
            <a
              href="https://www.tiktok.com/@brandingevents_studio?_r=1&_t=ZS-93FkrrzdEuI"
              style={styles.socialLink}
            >
              TikTok
            </a>
          </div>
        </div>

         <div style={styles.section}>
          <h4 style={styles.heading}>Important Info</h4>
          <Link to="/terms-and-conditions" style={styles.legalLink}>
          Terms & Conditions
        </Link>
        </div>
      </div>

      <div style={styles.bottom}>
        <span>© {new Date().getFullYear()} Branding & Events Studio</span>
      </div>
    </footer>
  );
}

const styles = {
  footer: {
    backgroundColor: "#2a2a2a",
    color: "#eaeaea",
    marginTop: "80px",
    padding: "60px 40px 30px",
  },

  container: {
    display: "grid",
    gridTemplateColumns: "repeat(auto-fit, minmax(220px, 1fr))",
    gap: "40px",
    maxWidth: "1200px",
    margin: "0 auto",
  },

  section: {
    textAlign: "left",
  },

  heading: {
    fontSize: "14px",
    letterSpacing: "1px",
    marginBottom: "14px",
    fontWeight: "500",
    textTransform: "uppercase",
  },

  description: {
    fontSize: "13px",
    lineHeight: "1.7",
    color: "#cfcfcf",
    maxWidth: "280px",
  },

  link: {
    fontSize: "13px",
    color: "#cfcfcf",
    marginBottom: "8px",
  },

  socials: {
    display: "flex",
    flexDirection: "column",
    gap: "8px",
  },

  socialLink: {
    fontSize: "13px",
    color: "#cfcfcf",
    textDecoration: "none",
    transition: "color 0.3s ease",
  },

  bottom: {
    marginTop: "40px",
    paddingTop: "20px",
    borderTop: "1px solid rgba(255,255,255,0.08)",
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    gap: "18px",
    fontSize: "12px",
    letterSpacing: "0.8px",
    color: "#bdbdbd",
    flexWrap: "wrap",
  },

  legalLink: {
    color: "#eaeaea",
    textDecoration: "none",
    fontSize: "12px",
  },
};
